export const ANDROID_DOWNLOAD_LINK = "https://play.google.com/store/apps/details?id=com.permulink";
export const ANDROID_DOWNLOAD_NAME = "PermuLink.apk";